import type { ReactNode } from "react";
import { cn } from "../cn";

const tileSizes = {
  sm: "size-9 [&_svg]:size-[18px]",
  md: "size-10 [&_svg]:size-5",
  lg: "size-12 [&_svg]:size-6",
};

/**
 * The one icon tile used across the app (card headers, stat cards, hints): soft brand pink with a
 * burgundy icon. Status colours stay on badges, where they carry meaning.
 */
export function IconTile({ children, size = "md", className }: { children: ReactNode; size?: keyof typeof tileSizes; className?: string }) {
  return (
    <span aria-hidden className={cn("flex shrink-0 items-center justify-center rounded-xl bg-primary-fixed/70 text-primary", tileSizes[size], className)}>
      {children}
    </span>
  );
}
